import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List, Map, fromJS } from 'immutable';

import { Segment, Grid, Button as SemanticButton, Icon, Popup, Image } from 'semantic-ui-react';

import { TagItem, DeclareExamFilter, Button, DeclareHeaderTab } from 'components';
import * as declareActions from 'modules/declare';
import { Tooltip } from 'material-ui';

import styles from './Declare.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class DeclareHeader extends Component {
  constructor(props) {
    super(props);
  }

  // 새로고침 버튼 클릭 이벤트
  onDeclareRefresh = () => {
    const { DeclareActions, declareRefresh } = this.props;
    DeclareActions.setDeclareRefresh({
      name: 'declareRefresh',
      value: !declareRefresh
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isModal, selectedTag, selectTarget, totalDeclareCount, tagDataByTagNo } = this.props;
    const { onDeclareRefresh } = this;
    let totalTagCount = selectedTag.size;

    let titleView;
    const TagArray = [];
    selectedTag.map(tagNo => {
      if (tagNo === 'all-tag') {
        totalTagCount = tagDataByTagNo.size;

        return (titleView = (
          <div key={tagNo} className={cx('targetHeader-selectTag')}>
            {defineMessages(formatMessage({ id: 'TargetHeader_1', defaultMessage: '모든 대상자' }))}
          </div>
        ));
      } else if (tagNo === 'no-tag') {
        totalTagCount = 0;

        return (titleView = (
          <div key={tagNo} className={cx('targetHeader-selectTag')}>
            {defineMessages(formatMessage({ id: 'TargetHeader_2', defaultMessage: '태그가 없는 대상자' }))}
          </div>
        ));
      } else if (typeof tagDataByTagNo.get(String(tagNo)) !== 'undefined') {
        titleView = (
          <div className={cx('targetHeader-tagTitle')} key={tagNo}>
            <div className={cx('ellipsis')}>
              <TagItem tagItem={tagDataByTagNo.get(String(selectedTag.get(0)))} />
            </div>
            {totalTagCount > 1 && (
              <div className={cx('targetHeader-subMessage')}>
                {defineMessages(formatMessage({ id: 'TargetHeader_3', defaultMessage: '외' })) +
                  ' ' +
                  defineMessages(formatMessage({ id: 'TargetHeader_11', defaultMessage: ' ' })) +
                  (totalTagCount - 1) +
                  defineMessages(formatMessage({ id: 'TargetHeader_4', defaultMessage: '개 태그' }))}
              </div>
            )}
          </div>
        );

        TagArray.push(<TagItem key={tagNo} tagItem={tagDataByTagNo.get(String(tagNo))} />);
      }
    });

    // 대상자 삭제 리스트
    let deleteTargetData = Map({});
    if (isModal === 'targetDelete') {
      deleteTargetData = Map({
        targetNoArray: selectTarget.get('targetNoArray')
      });
    }

    return (
      <div className={cx('targetHeader-wrapper', 'declareHeader-wrapper')}>
        <Segment vertical>
          <Grid columns="equal" stackable>
            <Grid.Row textAlign="left">
              <Grid.Column className={cx('targetHeader-column')}>
                {TagArray.length > 1 ? (
                  <Popup
                    className="max-250"
                    trigger={<div className={cx('targetHeader-Title')}>{titleView}</div>}
                    content={<div>{TagArray}</div>}
                    size="mini"
                    position="bottom left"
                  />
                ) : (
                    <div className={cx('targetHeader-Title')}>{titleView}</div>
                  )}
                <div className={cx('targetHeader-subTitle')}>
                  {defineMessages(formatMessage({ id: 'TargetHeader_5', defaultMessage: '총 대상자' })) +
                    ': ' +
                    totalDeclareCount +
                    defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' })) +
                    ', ' +
                    defineMessages(formatMessage({ id: 'TargetHeader_6', defaultMessage: '태그' })) +
                    ': ' +
                    totalTagCount +
                    defineMessages(formatMessage({ id: 'TargetHeader_7', defaultMessage: '개' }))}
                </div>
              </Grid.Column>
              {/* 새로고침 버튼 */}
              <Tooltip
                title={defineMessages(formatMessage({ id: 'ExamHeader_9', defaultMessage: '새로 고침' }))}
                classes={{ tooltip: 'tooltip-noMaxWidth' }}
                placement="bottom">
                <div className={cx('refresh')} onClick={onDeclareRefresh}>
                  <Image src="/img/exam/menu_refresh.png" />
                </div>
              </Tooltip>
              {/* 훈련/메뉴 탭 */}
              <DeclareHeaderTab />
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}

DeclareHeader.propTypes = {
  isModal: PropTypes.string,
  onAddTarget: PropTypes.func,
  onDeleteTarget: PropTypes.func,
  onToggleModal: PropTypes.func,
  handleChange: PropTypes.func
};

const mapStateToProps = state => ({
  declareRefresh: state.declare.get('declareRefresh')
});

const mapDispatchToProps = dispatch => ({
  DeclareActions: bindActionCreators(declareActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DeclareHeader));



// WEBPACK FOOTER //
// ./src/script/components/declare/DeclareHeader.js